import { createStore, combineReducers } from 'redux';
import DocumentReducer, { IDocumentState } from './modules/document';

export interface IStateTree {
    document: IDocumentState
}

export const store = createStore(
    combineReducers<IStateTree>({
        document: DocumentReducer
    }),
    (<any>window).__REDUX_DEVTOOLS_EXTENSION__ && (<any>window).__REDUX_DEVTOOLS_EXTENSION__()
);